import React, { lazy, Suspense, memo } from "react";
import { Footer } from "../Footer";
import { Contacto } from "./Contacto";

import MainNavbar from "../MainNavbar/MainNavbar";
import Inicio from "./Inicio";
import Funcionalidades from "./Funcionalidades";
import Planes from "./Planes";
import Testimonios from "./Testimonios";
import Mision from "./Mision";
import Rendimiento from "./Rendimiento";
import MultiCasas from "./MultiCasas";
import { ServiciosAdicionalesHome } from "./ServiciosAdicionalesHome";
import ElegirBlustay from "./ElegirBlustay";
import Integraciones from "./Integraciones";
import AgendaDemo from "./AgendaDemo";

const MemoInicio = memo(Inicio);
const MemoFuncionalidades = memo(Funcionalidades);
const MemoElegirBLustay = memo(ElegirBlustay);
const MemoTestimonios = memo(Testimonios);
const MemoMision = memo(Mision);
const MemoIntegraciones = memo(Integraciones);
//dasdsa
const Home = () => {
    return (
        <div translate="no" className="overflow-hidden ">
            <MainNavbar />
            <div id="inicio">
                <Suspense fallback={<div>Loading...</div>}>
                    <MemoInicio />
                </Suspense>
            </div>
            <div id="funcionalidades">
                <MemoFuncionalidades />
            </div>
            <div>
                <MemoElegirBLustay />
            </div>
            <div id="">
                <ServiciosAdicionalesHome />
            </div>
            <div>
                <MemoIntegraciones />
            </div>

            <div id="testimonios">
                <MemoTestimonios />
            </div>
            <div>
                <AgendaDemo />
            </div>

            <Footer />
        </div>
    );
};

export default Home;
